import { api } from "../../utils/api";
import { endpoints } from "../../utils/endpoints";
import { updateUltimateDiscover, setResults, setLoading } from "./ultimateDiscoverSlice";
import { setInfluencerDetails, setLoading as setDetailsLoading, setError } from "./ultimateDetailsSlice";
import { Alert } from "../../utils/Alert";

export const searchInfluencers = (append = false) => {
  return (dispatch, getState) => {
    const { platform, searchKeyword, filters, page, limit } = getState().ultimateDiscoverSlice;

    const requestBody = {
      platform: platform.toLowerCase(),
      filters: {},
      pagination: {
        page: page,
        limit: limit,
      },
    };

    // AI Search - main search text
    if (searchKeyword) {
      requestBody.filters.aiSearch = searchKeyword;
    }
    
    // Gender filter
    if (filters.gender) {
      requestBody.filters.gender = filters.gender.toLowerCase();
    }
    
    // Verified filter
    if (filters.isVerified === true) {
      requestBody.filters.isVerified = true;
    }
    
    // Follower range
    if (filters.minFollowers) {
      requestBody.filters.minFollowers = parseInt(filters.minFollowers);
    }
    if (filters.maxFollowers) {
      requestBody.filters.maxFollowers = parseInt(filters.maxFollowers);
    }
    
    // Engagement range
    if (filters.minEngagement) {
      requestBody.filters.minEngagement = parseFloat(filters.minEngagement);
    }
    if (filters.maxEngagement) {
      requestBody.filters.maxEngagement = parseFloat(filters.maxEngagement);
    }
    
    // Location - array of strings from dictionary
    if (filters.locations && filters.locations.length > 0) {
      requestBody.filters.locationArray = filters.locations;
    }
    
    // Categories - goes to keywords_in_captions
    if (filters.categories && filters.categories.length > 0) {
      requestBody.filters.categories = filters.categories;
    }
    
    // Languages - language codes/abbreviations
    if (filters.languages && filters.languages.length > 0) {
      requestBody.filters.languages = filters.languages;
    }
    
    //Brands filter
    if (filters.brands && filters.brands.length > 0) {
      requestBody.filters.brands = filters.brands;
    }
    
    // Audience interests
    if (filters.audienceInterests && filters.audienceInterests.length > 0) {
      requestBody.filters.audience = {
        ...(requestBody.filters.audience || {}),
        interests: filters.audienceInterests
      };
    }
    
    // Audience locations
    if (filters.audienceLocations && filters.audienceLocations.length > 0) {
      requestBody.filters.audience = {
        ...(requestBody.filters.audience || {}),
        location: filters.audienceLocations.map(loc => ({
          name: typeof loc === 'string' ? loc : loc.name,
          type: 'country',
          minPct: 10
        }))
      };
    }
    
    // Brand Deals filter
    if (filters.hasBrandDeals === true) {
      requestBody.filters.hasBrandDeals = true;
    }

    // Remove empty objects and arrays
    const cleanedBody = JSON.parse(JSON.stringify(requestBody, (key, value) => {
      if (value === undefined || value === null || (Array.isArray(value) && value.length === 0)) {
        return undefined;
      }
      if (typeof value === 'object' && value !== null && !Array.isArray(value) && Object.keys(value).length === 0) {
        return undefined;
      }
      return value;
    }));

    dispatch(setLoading(true));

    api.postApiCall(
      endpoints.influencerSearch,
      cleanedBody,
      (respData) => {
        dispatch(setLoading(false));
        if (respData.data.status === "SUCCESS") {
          const result = respData.data.result;
          dispatch(setResults({
            results: append ? (getState().ultimateDiscoverSlice.results || []).concat(result.influencers || []) : (result.influencers || []),
            total: result.total || 0,
            hasMore: result.hasMore || false,
            totalPages: Math.ceil((result.total || 0) / limit),
            searchRequestId: result.searchRequestId,
            creditsRemaining: result.creditsRemaining,
            source: result.source || null,
            ai: result.ai || null,
          }));
        } else {
          dispatch(updateUltimateDiscover({ results: [], totalCount: 0, totalPages: 0, hasMore: false }));
          Alert(2, respData.data.message || "Search failed");
        }
      },
      (error) => {
        // The error callback receives the axios response object, so the readable
        // message lives at error.data.message (not error.message).
        const message = error?.data?.message || "Something went wrong";
        dispatch(setLoading(false));
        dispatch(updateUltimateDiscover({ results: [], totalCount: 0, totalPages: 0, hasMore: false, error: message }));
        Alert(2, message);
      }
    );
  };
};

export const getDiscoveryLanguages = () => {
  return (dispatch) => {
    api.getApiCall(
      endpoints.discoveryLanguages,
      "",
      (respData) => {
        const payload = respData.data.result || respData.data || [];
        // These endpoints all back *List state, so never let a non-array through.
        const data = Array.isArray(payload) ? payload : [];
        console.log('Languages response:', data);
        dispatch(updateUltimateDiscover({ languagesList: data }));
      },
      (error) => {
        console.log("Error fetching languages:", error);
      }
    );
  };
};

export const getDiscoveryLocations = (platform = "instagram") => {
  return (dispatch) => {
    api.getApiCall(
      `${endpoints.discoveryLocations}/${platform}`,
      "",
      (respData) => {
        const payload = respData.data.result || respData.data || [];
        // These endpoints all back *List state, so never let a non-array through.
        const data = Array.isArray(payload) ? payload : [];
        console.log('Locations response:', data);
        dispatch(updateUltimateDiscover({ locationsList: data }));
      },
      (error) => {
        console.log("Error fetching locations:", error);
      }
    );
  };
};

export const getDiscoveryBrands = () => {
  return (dispatch) => {
    api.getApiCall(
      endpoints.discoveryBrands,
      "",
      (respData) => {
        const payload = respData.data.result || respData.data || [];
        // These endpoints all back *List state, so never let a non-array through.
        const data = Array.isArray(payload) ? payload : [];
        console.log('Brands response:', data);
        dispatch(updateUltimateDiscover({ brandsList: data }));
      },
      (error) => {
        console.log("Error fetching brands:", error);
      }
    );
  };
};

export const getDiscoveryYtTopicssss = () => {
  return (dispatch) => {
    api.getApiCall(
      endpoints.discoveryYtTopics,
      "",
      (respData) => {
        const payload = respData.data.result || respData.data || [];
        // These endpoints all back *List state, so never let a non-array through.
        const data = Array.isArray(payload) ? payload : [];
        console.log('YouTube Topics response:', data);
        dispatch(updateUltimateDiscover({ ytTopicsList: data }));
      },
      (error) => {
        console.log("Error fetching YouTube topics:", error);
      }
    );
  };
};

export const getDiscoveryAudienceInterests = () => {
  return (dispatch) => {
    api.getApiCall(
      endpoints.discoveryAudienceInterests,
      "",
      (respData) => {
        const payload = respData.data.result || respData.data || [];
        // These endpoints all back *List state, so never let a non-array through.
        const data = Array.isArray(payload) ? payload : [];
        console.log('Audience Interests response:', data);
        dispatch(updateUltimateDiscover({ audienceInterestsList: data }));
      },
      (error) => {
        console.log("Error fetching audience interests:", error);
      }
    );
  };
};

export const getDiscoveryAudienceLocations = () => {
  return (dispatch) => {
    api.getApiCall(
      endpoints.discoveryAudienceLocations,
      "",
      (respData) => {
        const payload = respData.data.result || respData.data || [];
        // These endpoints all back *List state, so never let a non-array through.
        const data = Array.isArray(payload) ? payload : [];
        console.log('Audience Locations response:', data);
        dispatch(updateUltimateDiscover({ audienceLocationsList: data }));
      },
      (error) => {
        console.log("Error fetching audience locations:", error);
      }
    );
  };
};

export const getDiscoveryAudienceBrandCategories = () => {
  return (dispatch) => {
    api.getApiCall(
      endpoints.discoveryAudienceBrandCategories,
      "",
      (respData) => {
        const payload = respData.data.result || respData.data || [];
        // These endpoints all back *List state, so never let a non-array through.
        const data = Array.isArray(payload) ? payload : [];
        console.log('Audience Brand Categories response:', data);
        dispatch(updateUltimateDiscover({ audienceBrandCategoriesList: data }));
      },
      (error) => {
        console.log("Error fetching audience brand categories:", error);
      }
    );
  };
};

export const getDiscoveryAudienceBrandNames = () => {
  return (dispatch) => {
    api.getApiCall(
      endpoints.discoveryAudienceBrandNames,
      "",
      (respData) => {
        const payload = respData.data.result || respData.data || [];
        // These endpoints all back *List state, so never let a non-array through.
        const data = Array.isArray(payload) ? payload : [];
        console.log('Audience Brand Names response:', data);
        dispatch(updateUltimateDiscover({ audienceBrandNamesList: data }));
      },
      (error) => {
        console.log("Error fetching audience brand names:", error);
      }
    );
  };
};

export const getAccountCredits = () => {
  return (dispatch) => {
    api.getApiCall(
      endpoints.influencerCredits,
      "",
      (respData) => {
        if (respData.data.status === "SUCCESS") {
          dispatch(updateUltimateDiscover({ credits: respData.data.result }));
        }
      },
      (error) => {
        console.log("Error fetching credits:", error);
      }
    );
  };
};

export const loadAllDictionaryData = () => {
  return (dispatch, getState) => {
    // Locations & languages come from the backend cache, which is kept in sync
    // with influencers.club (Indian-only, IC-valid) by a cron. Fetching them
    // here ensures the dropdowns only offer values IC actually accepts, so a
    // user never picks something the backend silently drops.
    dispatch(getDiscoveryLocations());
    dispatch(getDiscoveryLanguages());
    dispatch(getDiscoveryBrands());
    dispatch(getDiscoveryAudienceInterests());
    dispatch(getDiscoveryAudienceLocations());
  };
};

export const getUniqueInfluencerDetails = (id) => {
  return (dispatch) => {
    dispatch(setDetailsLoading(true));
    api.getApiCall(
      `${endpoints.influencerSearchDetails}/${id}`,
      "",
      (respData) => {
        dispatch(setDetailsLoading(false));
        if (respData.data.status === "SUCCESS") {
          dispatch(setInfluencerDetails(respData.data.result));
        } else {
          dispatch(setError(respData.data.message || "Failed to fetch details"));
          Alert(2, respData.data.message || "Failed to fetch details");
        }
      },
      (error) => {
        const message = error?.data?.message || "Something went wrong";
        dispatch(setDetailsLoading(false));
        dispatch(setError(message));
        Alert(2, message);
      }
    );
  };
};